const secrets = {
    third_party_token_set: {
        token_not_found: 'Không tìm thấy bản ghi token.',
        access_token_expired: 'Access token đã hết hạn. Vui lòng kết nối lại tài khoản của bạn.',
    },
};
export default Object.freeze(secrets);
